// Default view types
export const DEFAULT_VIEWS = [
  { id: 'flow', type: 'flow', name: 'Flow', isDefault: true },
  { id: 'kanban', type: 'kanban', name: 'Kanban', isDefault: true },
  { id: 'table', type: 'table', name: 'Table', isDefault: true },
  { id: 'gantt', type: 'gantt', name: 'Gantt', isDefault: true },
  { id: 'todolist', type: 'todolist', name: 'Todo', isDefault: true },
  { id: 'neural', type: 'neural', name: 'Astra', isDefault: true },
];

// Status colors for missions
export const STATUS_COLORS = {
  pending: '#6b7280',
  in_progress: '#60a5fa',
  completed: '#4ade80',
  blocked: '#f87171',
};
